import http from "../axios/http-common";

class InterfaceResume {
  getDiagnosis(term) {
    return http.getDataParam(`/referensi/diagnosis-icd/search`, {
      params: {
        term: term
      }
    });
  }
  getProcedure(term) {
    return http.getDataParam(`/referensi/prosedur-icd/search`, {
      params: {
        term: term
      }
    });
  }
  getDischarge(term) {
    return http.getDataParam(`/referensi/cara-pulang/search`, {
      params: {
        term: term
      }
    });
  }
  getResume(reg, idUser) {
    return http.getDataParam(`/register/${reg}/resume-ralan`, {
      params: {
        dpjp_id: idUser
      }
    });
  }
  saveResume(
    reg,
    cm,
    dpjp,
    discharge,
    rujukan,
    catatan,
    user_id,
    diag,
    proc,
    tlPrb = null,
    tlPrbNote = null
  ) {
    return http.postData(`/register/${reg}/resume-ralan-paket`, {
      // reg: reg,
      pasien_rm: cm,
      dpjp_id: dpjp,
      discharge_id: discharge,
      rujukan_ke: rujukan,
      catatan: catatan,
      user_id: user_id,
      diagnosis: diag,
      prosedur: proc,
      tl_prb_id: tlPrb,
      tl_prb_note: tlPrbNote
    });
  }
  editResume(
    reg,
    cm,
    dpjp,
    discharge,
    rujukan,
    catatan,
    user_id,
    diag,
    proc,
    tlPrb = null,
    tlPrbNote = null
  ) {
    return http.putData(`/register/${reg}/resume-ralan-paket`, {
      // reg: reg,
      pasien_rm: cm,
      dpjp_id: dpjp,
      discharge_id: discharge,
      rujukan_ke: rujukan,
      catatan: catatan,
      user_id: user_id,
      diagnosis: diag,
      prosedur: proc,
      tl_prb_id: tlPrb,
      tl_prb_note: tlPrbNote
    });
  }
  saveTtdResume(reg, user_id, password) {
    return http.postData(`/register/${reg}/resume-ralan-paket/signature`, {
      dpjp_id: user_id,
      password: password
    });
  }
}

export default new InterfaceResume();
